import React from 'react';
import { Button, Divider, Grid2 as Grid, Stack, SvgIcon, Theme, Typography, useTheme } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@mui/styles';
import chartIconSrc from '../images/chartIcon.svg';
import { IntegrationStatus } from '../constants/IntegrationStatus';
import { I18nKeys } from '../constants/I18nKeys';
import { MenuIcon, MenuIconKey } from './MenuIcon';
import { useAppSelector } from '../hooks';
import { openDialog } from '../ducks/dialogSlice';
import { Dialogs } from '../constants/Dialogs';
import { startPaymentIntegration } from '../ducks/integrationSlice';

const ReachMoreCustomerIcon = () => {
  const theme = useTheme();
  return (
    <SvgIcon color="primary" style={{ overflow: 'visible' }}>
      <path
        d="M3.66232 0.660198L3.76839 0.766264C3.37432 1.16034 3.15268 1.69453 3.15201 2.25178C3.15201 2.25184 3.15201 2.25189 3.15201 2.25195M3.66232 0.660198L3.00201 2.25178L3.15201 2.25195M3.66232 0.660198L3.76839 0.766264C4.16237 0.372275 4.69675 0.150634 5.25408 0.15L32.1151 0.15C32.6724 0.150643 33.2066 0.372289 33.6007 0.766279C33.9947 1.16039 34.2163 1.69464 34.217 2.25195L34.2172 15.6915C34.2164 16.091 34.1022 16.4819 33.8879 16.819L33.8432 16.8894L33.8794 16.9646C34.5232 18.2999 34.7618 19.7944 34.5659 21.2637C34.3699 22.733 33.7481 24.1128 32.7769 25.2327C31.8057 26.3526 30.5279 27.1636 29.1012 27.5656C27.6743 27.9676 26.1611 27.943 24.7481 27.4947C23.3351 27.0465 22.0843 26.1943 21.1502 25.0435L21.0338 25.1381L21.1502 25.0435C20.216 23.8927 19.6394 22.4934 19.4914 21.0185L19.4778 20.8835H19.3421H2.25195C1.6947 20.8828 1.16053 20.6611 0.766394 20.2671C0.372401 19.873 0.150766 19.3389 0.15 18.7816V5.34128C0.150757 4.78401 0.372403 4.24988 0.766366 3.85591C1.16046 3.46192 1.69467 3.24031 2.25181 3.23974C2.25184 3.23974 2.25188 3.23974 2.25192 3.23974M3.66232 0.660198L2.25192 3.23974M3.15201 2.25195L3.15201 3.08963V3.23961L3.00203 3.23963L2.25192 3.23974M3.15201 2.25195L2.25192 3.23974M31.5161 14.1545L31.2724 13.9596L31.2722 13.9594L31.3584 13.8424H31.2161V5.34153C31.2154 4.7842 30.9936 4.24994 30.5995 3.85594C30.2054 3.46198 29.6711 3.24044 29.1139 3.23986C29.1138 3.23986 29.1138 3.23986 29.1137 3.23986M31.5161 14.1545L29.1139 3.08986L29.1137 3.23986M31.5161 14.1545V14.1315M31.5161 14.1545V14.1315M29.1137 3.23986L4.82417 3.23986H4.67417V3.08986V2.2519V2.25175C4.67432 2.09789 4.73552 1.95031 4.84435 1.84149C4.95319 1.73264 5.10078 1.67146 5.25473 1.67131L5.25488 1.67131L32.1162 1.67131H32.1163C32.2702 1.67146 32.4178 1.73262 32.5266 1.84141C32.6356 1.95027 32.6968 2.09784 32.6971 2.2516V2.2519V14.8243V15.19L32.4403 14.9296C32.1539 14.6392 31.8449 14.3723 31.5161 14.1315M29.1137 3.23986L31.5161 14.1315M1.67225 5.34133V18.6231L1.67173 18.6231L1.67205 18.7821C1.67235 18.9359 1.73354 19.0833 1.84234 19.1921C1.95114 19.3009 2.09855 19.3621 2.25234 19.3624H2.25263H19.3772H19.5082L19.5258 19.2326C19.7275 17.7478 20.3646 16.3559 21.3566 15.2329C22.3488 14.1098 23.6514 13.3059 25.1 12.9225C26.5484 12.5391 28.0782 12.5935 29.4959 13.0788L29.6945 13.1468V12.9369V5.34133V5.34103C29.6942 5.18728 29.633 5.03975 29.5242 4.93091C29.4154 4.8221 29.2679 4.76089 29.1139 4.76074H29.1138H3.97566H3.96412L3.95272 4.7625C3.94551 4.76362 3.93678 4.76391 3.91372 4.76391C3.90972 4.76391 3.90479 4.76361 3.89342 4.76275L3.8919 4.76263C3.88228 4.7619 3.86693 4.76074 3.85077 4.76074H2.25284H2.25269C2.09879 4.76089 1.95134 4.82212 1.84254 4.93092C1.73371 5.03975 1.67255 5.18728 1.67225 5.34103V5.34133ZM33.1123 20.2607V20.2606C33.1125 19.0604 32.7568 17.8869 32.09 16.8888C31.4233 15.8907 30.4755 15.1127 29.3667 14.6532C28.2579 14.1937 27.0376 14.0734 25.8604 14.3075C24.6831 14.5415 23.6017 15.1194 22.7528 15.9682C21.9041 16.8168 21.326 17.8982 21.0918 19.0754C20.8576 20.2526 20.9778 21.4729 21.4371 22.5818C21.8964 23.6907 22.6744 24.6385 23.6724 25.3053L23.7557 25.1806L23.6724 25.3053C24.6705 25.9722 25.8438 26.3281 27.0441 26.328L27.0441 26.328C28.6529 26.3261 30.195 25.6862 31.3326 24.5489C32.4702 23.4115 33.1102 21.8694 33.1123 20.2607Z"
        fill={theme.palette.primary.main}
        stroke="white"
        strokeWidth="0.3"
      />
      <path
        d="M20.4071 12.0347L20.4071 12.0168C20.4069 10.7517 19.9042 9.53864 19.0096 8.64428L19.0096 8.64427C18.1151 7.74986 16.9019 7.24755 15.6369 7.24766L20.4071 12.0347ZM20.4071 12.0347C20.401 13.2928 19.8987 14.498 19.0088 15.388C18.1147 16.2824 16.9024 16.7855 15.6376 16.787C14.3727 16.7871 13.1596 16.2847 12.2651 15.3903L12.159 15.4964L12.2651 15.3903C11.3705 14.4959 10.8679 13.2827 10.8678 12.0178C10.8677 10.7528 11.37 9.53959 12.2644 8.64507L12.2644 8.64507C13.1587 7.75054 14.3719 7.24788 15.6369 7.24766L20.4071 12.0347ZM15.6377 15.2661H15.7005L15.7012 15.2654C16.5397 15.2481 17.34 14.9074 17.934 14.3132C18.5429 13.704 18.8854 12.8782 18.8862 12.0169V12.0167C18.8858 11.1551 18.5434 10.3291 17.9341 9.72009C17.3248 9.11113 16.4985 8.76915 15.637 8.76927H15.637C14.7756 8.76951 13.9495 9.11183 13.3404 9.72115C12.7313 10.3304 12.3892 11.1567 12.3894 12.0181C12.3894 12.8796 12.7317 13.7057 13.3409 14.3148C13.9501 14.9239 14.7762 15.2661 15.6377 15.2661Z"
        fill={theme.palette.primary.main}
        stroke="white"
        strokeWidth="0.3"
      />
      <path
        d="M31.0871 18.9846L27.2225 22.8454C27.0518 23.0161 26.8204 23.1118 26.579 23.1118C26.3377 23.1118 26.1062 23.0161 25.9356 22.8454L23.3616 20.2715C23.1807 20.1031 23.0759 19.8684 23.0714 19.6212M31.0871 18.9846L30.4532 17.5573C30.6596 17.5537 30.8587 17.6341 31.0047 17.7801L31.0047 17.7801C31.1507 17.926 31.2311 18.1251 31.2273 18.3316L31.2273 18.3316C31.2236 18.5381 31.1361 18.7341 30.9849 18.8747L30.9848 18.8747L30.981 18.8785L27.1164 22.7393L27.1164 22.7394C26.9739 22.8818 26.7807 22.9618 26.579 22.9618C26.3775 22.9618 26.1841 22.8818 26.0416 22.7394L23.4677 20.1654L23.4678 20.1654L23.4638 20.1617C23.3127 20.021 23.2251 19.825 23.2214 19.6186L23.0714 19.6212M31.0871 18.9846C31.2681 18.8162 31.3728 18.5815 31.3773 18.3343L31.0871 18.9846ZM23.0714 19.6212L23.2214 19.6186C23.2177 19.4121 23.298 19.213 23.444 19.067C23.5901 18.921 23.7891 18.8406 23.9955 18.8444L23.9956 18.8444C24.2021 18.8481 24.3981 18.9355 24.5387 19.0868L24.6446 19.2007L24.6486 19.1966L26.4741 21.0224L26.5801 21.1285L26.6862 21.0224L29.807 17.9013L29.8119 17.9054L29.91 17.7998C30.0506 17.6486 30.2466 17.5611 30.4531 17.5573L23.9983 18.6944C23.7511 18.6899 23.5128 18.7861 23.338 18.9609C23.1632 19.1357 23.067 19.3741 23.0714 19.6212Z"
        fill={theme.palette.primary.main}
        stroke="white"
        strokeWidth="0.3"
      />
    </SvgIcon>
  );
};

const SimplifyShoppingIcon = () => {
  const theme = useTheme();
  return (
    <SvgIcon color="primary" style={{ overflow: 'visible' }}>
      <svg width="28" height="29" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M22.2619 14.7069H6.66607C6.46405 14.7069 6.26203 14.5857 6.14075 14.3836C6.01949 14.1816 6.01949 13.9796 6.14075 13.7776L13.9387 0.282772C14.0599 0.0807536 14.2619 0 14.464 0C14.666 0 14.868 0.121265 14.9893 0.282772L22.7872 13.7776C22.9084 13.9796 22.9084 14.1816 22.7872 14.3836C22.6658 14.5857 22.4638 14.7069 22.2618 14.7069H22.2619ZM7.71656 13.4948H21.2114L14.464 1.81816L7.71656 13.4948Z"
          fill={theme.palette.primary.main}
        />
        <path
          d="M27.3935 29.0098H15.232C14.9087 29.0098 14.626 28.7271 14.626 28.4038V16.2423C14.626 15.919 14.9087 15.6362 15.232 15.6362H27.3935C27.7168 15.6362 27.9996 15.919 27.9996 16.2423V28.4038C27.9996 28.7269 27.7167 29.0098 27.3935 29.0098ZM15.8381 27.7977H26.7875V16.8483H15.8381V27.7977Z"
          fill={theme.palette.primary.main}
        />
        <path
          d="M6.6666 28.9694C2.98987 28.9694 0 25.9795 0 22.3028C0 18.6261 2.9899 15.6362 6.6666 15.6362C10.3433 15.6362 13.3332 18.6261 13.3332 22.3028C13.3332 25.9796 10.3433 28.9694 6.6666 28.9694ZM6.6666 16.8483C3.6767 16.8483 1.21211 19.3129 1.21211 22.3028C1.21211 25.2927 3.6767 27.7573 6.6666 27.7573C9.6565 27.7573 12.1211 25.2927 12.1211 22.3028C12.1211 19.3129 9.6565 16.8483 6.6666 16.8483Z"
          fill={theme.palette.primary.main}
        />
      </svg>
    </SvgIcon>
  );
};

const SecureReliableIcon = () => {
  const theme = useTheme();
  return (
    <SvgIcon color="primary" style={{ overflow: 'visible' }}>
      <svg width="23" height="26" viewBox="0 0 23 26" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M14.1568 10.3673L10.5196 14.4878L8.79615 12.9629C8.5824 12.7741 8.25379 12.7932 8.06386 13.0075C7.87393 13.2222 7.89416 13.5498 8.10838 13.7398L10.2208 15.6086C10.316 15.6926 10.4386 15.7388 10.5647 15.7388C10.5752 15.7388 10.5859 15.7383 10.5965 15.7377C10.7338 15.7291 10.8623 15.6663 10.9536 15.5635L14.9348 11.054C15.1242 10.8393 15.1039 10.5116 14.8892 10.3217C14.6744 10.1323 14.3473 10.1525 14.1568 10.3673L14.1568 10.3673Z"
          fill={theme.palette.primary.main}
        />
        <path
          d="M11.4994 6.60986C7.99475 6.60986 5.14355 9.4613 5.14355 12.9657C5.14355 16.4701 7.99499 19.3215 11.4994 19.3215C15.0038 19.3215 17.8552 16.4701 17.8552 12.9657C17.8552 9.4613 15.0038 6.60986 11.4994 6.60986ZM11.4994 18.2845C8.56664 18.2845 6.1806 15.8987 6.1806 12.9657C6.1806 10.0329 8.56654 7.6469 11.4994 7.6469C14.4322 7.6469 16.8182 10.0328 16.8182 12.9657C16.8182 15.8986 14.4322 18.2845 11.4994 18.2845Z"
          fill={theme.palette.primary.main}
        />
        <path
          d="M22.9999 8.26762C22.9817 7.09364 22.9224 5.8726 22.8237 4.63785C22.7883 4.20535 22.571 3.92277 22.1577 3.77388C18.7615 2.55433 15.3691 1.32467 11.9775 0.092082C11.6438 -0.0284543 11.3389 -0.0310051 11.0193 0.0865043C7.62861 1.32069 4.23578 2.54999 0.840527 3.77C0.433358 3.91634 0.216584 4.1959 0.177619 4.62538C-0.0487993 7.15009 -0.0589132 9.41246 0.148219 11.542C0.448562 14.6349 1.13122 17.088 2.2966 19.2623C4.11985 22.6631 6.83296 24.8449 10.3608 25.7459C10.6935 25.831 11.085 25.9307 11.5125 25.9307C11.6766 25.9307 11.8462 25.9161 12.02 25.8801C12.965 25.6841 13.7743 25.4359 14.4941 25.1203C17.7601 23.6861 20.0489 21.2036 21.4908 17.5302C22.5098 14.9346 22.9752 12.0815 23 8.27939L22.9999 8.26762ZM20.5253 17.1513C19.1888 20.5562 17.0795 22.8525 14.0773 24.1703C13.425 24.4564 12.683 24.6833 11.8094 24.8641C11.4179 24.9472 11.0118 24.8413 10.6172 24.741C7.33737 23.9028 4.91454 21.9506 3.21074 18.7719C2.11221 16.7228 1.46699 14.3936 1.18035 11.4415C0.981818 9.39331 0.989948 7.21248 1.21069 4.73907C4.60135 3.52056 7.98861 2.29349 11.3747 1.06066C11.4537 1.03126 11.5089 1.02521 11.6233 1.06671C14.9982 2.29381 18.3748 3.51688 21.7914 4.74705C21.887 5.94787 21.9443 7.13602 21.9626 8.27808C21.9384 11.9439 21.4947 14.6806 20.5254 17.1511L20.5253 17.1513Z"
          fill={theme.palette.primary.main}
        />
      </svg>
    </SvgIcon>
  );
};

const infoSection = [
  {
    key: 'ReachMoreCustomerSection',
    iconAlt: 'Reach More Customers icon',
    icon: <ReachMoreCustomerIcon />,
    title: I18nKeys.SetupPaymentIntegrationReachMoreCustomersTitle,
    subtitle: I18nKeys.SetupPaymentIntegrationReachMoreCustomersSubtitle,
    link: I18nKeys.SetupPaymentIntegrationReachMoreCustomersLink,
    linkText: I18nKeys.SetupPaymentIntegrationLearnMoreLinkText,
  },
  {
    key: 'SimplifyShoppingSection',
    iconAlt: 'Simplify Shopping icon',
    icon: <SimplifyShoppingIcon />,
    title: I18nKeys.SetupPaymentIntegrationSimplifyShoppingTitle,
    subtitle: I18nKeys.SetupPaymentIntegrationSimplifyShoppingSubtitle,
    link: I18nKeys.SetupPaymentIntegrationSimplifyShoppingLink,
    linkText: I18nKeys.SetupPaymentIntegrationLearnMoreLinkText,
  },
  {
    key: 'SecureReliableSection',
    iconAlt: 'Secure & Reliable icon',
    icon: <SecureReliableIcon />,
    title: I18nKeys.SetupPaymentIntegrationSecureRiableTitle,
    subtitle: I18nKeys.SetupPaymentIntegrationSecureRiableSubtitle,
    link: I18nKeys.SetupPaymentIntegrationSecureRiableLink,
    linkText: I18nKeys.SetupPaymentIntegrationLearnMoreLinkText,
  },
];

const TopContent = {
  [IntegrationStatus.DISCONNECTED]: {
    title: I18nKeys.SetupPaymentIntegrationTitle,
    subtitle: I18nKeys.SetupPaymentIntegrationSubtitle,
    iconKey: undefined,
    defaultMessage: undefined,
    buttonTitle: I18nKeys.SetupPaymentIntegrationGetStarted,
  },
  [IntegrationStatus.PENDING]: {
    title: I18nKeys.SetupPaymentIntegrationPendingTitle,
    subtitle: I18nKeys.SetupPaymentIntegrationPendingSubtitle,
    iconKey: MenuIconKey.ATTENTION,
    buttonTitle: I18nKeys.SetupPaymentIntegrationViewDetails,
    defaultMessage: I18nKeys.SetupPaymentIntegrationPendingDefaultMessage,
  },
  [IntegrationStatus.FAILED]: {
    title: I18nKeys.SetupPaymentIntegrationFailedTitle,
    subtitle: I18nKeys.SetupPaymentIntegrationFailedSubtitle,
    iconKey: MenuIconKey.WARNING,
    buttonTitle: I18nKeys.SetupPaymentIntegrationFixProblems,
    defaultMessage: I18nKeys.SetupPaymentIntegrationFailedDefaultMessage,
  },
};

interface StyleProps {
  disconnected: boolean;
}

const useStyles = makeStyles<Theme, StyleProps>(() => ({
  root: { width: '100%', height: '100%', padding: '50px 62px' },
  flex: { display: 'flex' },
  topSection: ({ disconnected }) => ({
    flex: disconnected ? '1' : '0',
  }),
  chartIconCircle: {
    height: 0,
    width: 0,
    minWidth: '91px',
    minHeight: '91px',
    background: '#0000001A',
    borderRadius: '50%',
    margin: '0 24px',
    display: 'flex',
  },
  topSectionMiddleContainer: { alignSelf: 'center', padding: '0px 28px' },
  topSectionTitle: {
    fontSize: '20px',
    fontWeight: '600',
    lineHeight: '23.44px',
    color: '#000',
  },
  topSectionSubtitle: {
    fontSize: '15px',
    fontWeight: '400',
    lineHeight: '22px',
    color: '#1E1E1E',
    paddingTop: '12px',
  },
  topIconContainer: { width: '100%', marginTop: '12px' },
  topIconStatusText: {
    fontSize: '15px',
    fontWeight: '400',
    lineHeight: '22px',
    paddingTop: '3px',
    color: '#1E1E1E',
  },
  topButtonContainer: { display: 'flex', justifyContent: 'end' },
  topButton: {
    marginTop: '24px',
    borderRadius: '4px',
    padding: '22px 36px',
    marginRight: '28px',
    textTransform: 'none',
    height: 0,
  },
  topButtonText: {
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '20px',
    alignSelf: 'center',
  },
  middleContainer: { flex: '2' },
  middleItemContainer: { padding: '0px 28px' },
  middleItemText: {
    fontSize: '16px',
    fontWeight: '600',
    lineHeight: '18.75px',
    color: '#000',
    marginTop: '12px',
  },
  middleItemSubtitle: {
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '16.94px',
    color: '#323B4B',
    marginTop: '12px',
  },
  middleItemLink: {
    marginTop: '12px',
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '16.94px',
  },
  bottomContainer: { width: '100%', height: '100%', flex: '2' },
  bottomTopContainer: {
    display: 'flex',
    flex: '1',
    padding: '0px 28px 12px',
    alignItems: 'start',
    justifyContent: 'start',
    width: '100%',
    flexDirection: 'column',
  },
  bottomWhatYouNeedText: {
    fontSize: '16px',
    fontWeight: '600',
    lineHeight: '24px',
    color: '#000',
  },
  bottomList: {
    padding: '0px 24px 0px',
  },
  bottomListItem: {
    fontSize: '14px',
    fontWeight: '400',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: '#323B4B',
  },
  bottomGrayContainer: { flex: '1', borderRadius: '10px', backgroundColor: '#F7F7F7' },
  bottomSetupText: {
    fontSize: '20px',
    fontWeight: '600',
    lineHeight: '23.44px',
    textAlign: 'left',
    color: '#000',
    alignSelf: 'center',
    marginLeft: '28px',
  },
  bottomButtonContainer: { display: 'flex', alignItems: 'center', justifyContent: 'end' },
  bottomButton: {
    textTransform: 'none',
    borderRadius: '4px',
    padding: '22px 36px',
    backgroundColor: 'white',
    height: 0,
    marginRight: '28px',
  },
  bottomButtonText: {
    fontSize: '16px',
    fontWeight: '500',
    lineHeight: '20px',
  },
}));

export const SetupPaymentIntegration: React.FC = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { paymentIntegrationStatus = { status: IntegrationStatus.DISCONNECTED } } = useAppSelector(
    (state) => state.viewer,
  );
  const disconnected = paymentIntegrationStatus.status === IntegrationStatus.DISCONNECTED;
  const classes = useStyles({ disconnected });
  const documentList = [
    I18nKeys.SetupPaymentIntegrationWhatYouWillNeedDocuments,
    I18nKeys.SetupPaymentIntegrationWhatYouWillNeedBank,
  ];

  const handleButtonClick = () => {
    dispatch(startPaymentIntegration());
    dispatch(
      openDialog({
        dialog: Dialogs.Loading,
        options: {
          title: t(I18nKeys.SetupPaymentIntegrationLoadingTitle),
          content: t(I18nKeys.SetupPaymentIntegrationLoadingContent),
        },
      }),
    );
  };

  if (paymentIntegrationStatus.status === IntegrationStatus.CONNECTED) {
    return <div />;
  }

  return (
    <Stack className={classes.root} direction="column" alignItems="center" spacing={4} divider={<Divider flexItem />}>
      <Grid className={classes.topSection} container>
        <Grid className={classes.flex} size={{ xs: 2 }}>
          <div className={classes.chartIconCircle}>
            <img alt="Chart Icon" src={chartIconSrc} style={{ margin: 'auto' }} />
          </div>
        </Grid>
        <Grid className={classes.flex} size={{ xs: 7 }}>
          <div className={classes.topSectionMiddleContainer}>
            <Typography className={classes.topSectionTitle}>
              {t(TopContent[paymentIntegrationStatus.status].title)}
            </Typography>
            <Typography
              className={classes.topSectionSubtitle}
              dangerouslySetInnerHTML={{
                __html: t(TopContent[paymentIntegrationStatus.status].subtitle),
              }}
            />
            {TopContent[paymentIntegrationStatus.status].iconKey && (
              <Stack className={classes.topIconContainer} direction="row">
                <MenuIcon iconKey={TopContent[paymentIntegrationStatus.status].iconKey} />
                <Typography className={classes.topIconStatusText}>
                  <Trans
                    i18nKey={I18nKeys.SetupPaymentIntegrationStatus as string}
                    values={{
                      message:
                        paymentIntegrationStatus.message ||
                        t(TopContent[paymentIntegrationStatus.status].defaultMessage || ''),
                    }}
                    components={{ bold: <strong /> }}
                  />
                </Typography>
              </Stack>
            )}
          </div>
        </Grid>
        <Grid className={classes.topButtonContainer} size={{ xs: 3 }}>
          <Button color="primary" variant="contained" onClick={handleButtonClick} className={classes.topButton}>
            <Typography className={classes.topButtonText}>
              {t(TopContent[paymentIntegrationStatus.status].buttonTitle)}
            </Typography>
          </Button>
        </Grid>
      </Grid>
      {disconnected && (
        <Grid className={classes.middleContainer} container>
          {infoSection.map((item) => (
            <Grid key={item.key} size={{ xs: 4 }} className={classes.middleItemContainer}>
              {item.icon}
              <Typography
                className={classes.middleItemText}
                dangerouslySetInnerHTML={{
                  __html: t(item.title),
                }}
              />
              <Typography className={classes.middleItemSubtitle}>{t(item.subtitle)}</Typography>
              <Typography className={classes.middleItemLink}>
                <a href={t(item.link)} target="_blank" rel="noreferrer">
                  {t(item.linkText)}
                </a>
              </Typography>
            </Grid>
          ))}
        </Grid>
      )}
      {disconnected && (
        <Stack className={classes.bottomContainer} direction="column" alignItems="center" spacing={2}>
          <div className={classes.bottomTopContainer}>
            <Typography className={classes.bottomWhatYouNeedText}>
              {t(I18nKeys.SetupPaymentIntegrationWhatYouWillNeed)}
            </Typography>
            <ul className={classes.bottomList}>
              {documentList.map((doc) => (
                <li key={doc}>
                  <Typography className={classes.bottomListItem}>{t(doc)}</Typography>
                </li>
              ))}
            </ul>
          </div>
          <Grid className={classes.bottomGrayContainer} container>
            <Grid className={classes.flex} size={{ xs: 6 }}>
              <Typography className={classes.bottomSetupText}>
                {t(I18nKeys.SetupPaymentIntegrationStartAcceptingOrder)}
              </Typography>
            </Grid>
            <Grid className={classes.bottomButtonContainer} size={{ xs: 6 }}>
              <Button onClick={handleButtonClick} className={classes.bottomButton} color="primary" variant="outlined">
                <Typography className={classes.bottomButtonText}>
                  {t(I18nKeys.SetupPaymentIntegrationGetStarted)}
                </Typography>
              </Button>
            </Grid>
          </Grid>
        </Stack>
      )}
    </Stack>
  );
};
